import { Box, Collapse, IconButton, Stack, Typography } from '@mui/material'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import Link from 'next/link'
import React, { useState } from 'react'
import { Image } from '@/components'

type Props = {
  open?: boolean
  categories?: ICategoryMenu | null | undefined
}

export default function SubMenuMobile({ categories, open = false }: Props) {
  const [openCategories, setOpenCategories] = useState<Record<string, boolean>>({})
  console.log('categories', categories)

  const toggleCategory = (uid: string) => {
    setOpenCategories((prev) => ({
      ...prev,
      [uid]: !prev[uid],
    }))
  }

  return (
    <Collapse in={open} timeout="auto" unmountOnExit>
      <Stack spacing={1} pl={'0.8px'} borderLeft={'0.1rem solid #eee'}>
        {categories?.children.map((category) => {
          if (category?.include_in_menu === 0 || category?.children?.length === 0) return null

          const hasChildren = category?.children && category.children.length > 0
          const isCategoryOpen = openCategories[category.uid] || false

          return (
            <Box key={category.uid}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  gap: 1,
                }}
              >
                <Link
                  href={category.url_path ? '/' + category.url_path : '#'}
                  style={{ textDecoration: 'none', flex: 1 }}
                >
                  <Typography
                    component={'div'}
                    sx={{
                      fontSize: '14px',
                      fontWeight: 500,
                      color: 'primary.main',
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                      textTransform: 'uppercase',
                      p: 1,
                      borderRadius: 1,
                      transition: 'all 0.2s',
                    }}
                  >
                    {category?.icon_image && (
                      <Stack sx={{ width: '14px', height: '14px' }}>
                        <Image src={category.icon_image || ''} alt={category.name} />
                      </Stack>
                    )}
                    {category.name}
                  </Typography>
                </Link>

                {hasChildren && (
                  <IconButton
                    size="small"
                    onClick={() => toggleCategory(category.uid)}
                    sx={{
                      transition: 'transform 0.2s ease',
                      transform: isCategoryOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                    }}
                  >
                    <KeyboardArrowDownIcon fontSize="small" />
                  </IconButton>
                )}
              </Box>
              {hasChildren && (
                <Collapse in={isCategoryOpen} timeout="auto" unmountOnExit>
                  <Stack spacing={1} pl={2}>
                    {category.children.map((subCategory) => {
                      if (subCategory?.include_in_menu === 0) return null
                      return (
                        <Box key={subCategory.uid}>
                          <Link
                            href={subCategory.url_path ? '/' + subCategory.url_path : '#'}
                            style={{ textDecoration: 'none' }}
                          >
                            <Typography
                              component={'span'}
                              sx={{
                                fontSize: '14px',
                                fontWeight: 400,
                                color: 'primary.main',
                                display: 'block',
                                p: 0.75,
                                pl: 0.4,
                              }}
                            >
                              {subCategory.name}
                            </Typography>
                          </Link>
                        </Box>
                      )
                    })}
                  </Stack>
                </Collapse>
              )}
            </Box>
          )
        })}
      </Stack>
    </Collapse>
  )
}
